// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"677":"97998ae4","697":"1533b1d2"}[chunkId] + ".chunk.css";
};